import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { PV } from '@/constants/testIds';
import { Stethoscope, Building2, Scissors, Hospital, Network, Briefcase, ArrowUpRight } from 'lucide-react';
import SectionActions from './SectionActions';

const ICONS = [Stethoscope, Building2, Scissors, Briefcase, Hospital, Network];

export const TargetAudience = ({ compact = false }) => {
  const { t } = useLanguage();

  return (
    <section
      id="target"
      data-testid={PV.targetSection}
      className="relative bg-white py-20 md:py-28 border-t border-slate-100"
    >
      <div className="pv-container">
        {!compact && (
          <div className="max-w-2xl">
            <span className="text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.18em] text-slate-500">
              {t.target.eyebrow}
            </span>
            <h2 className="mt-4 font-heading font-bold tracking-normal text-[32px] sm:text-[40px] md:text-[48px] leading-[1.08] text-pv-ink">
              {t.target.title_a} <br />
              <span className="text-pv-teal">{t.target.title_b}</span>
            </h2>
          </div>
        )}

        <div className={`${compact ? '' : 'mt-12 md:mt-14'} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6`}>
          {t.target.cards.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <article
                key={i}
                data-testid={PV.targetCard}
                className="group pv-card relative overflow-hidden"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-11 h-11 rounded-xl bg-pv-ice border border-pv-teal/25 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-pv-teal" />
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-slate-400 font-semibold">0{i + 1}</span>
                </div>
                <h3 className="font-heading font-bold text-[18px] md:text-[20px] text-pv-ink leading-tight">
                  {c.title}
                </h3>
                <p className="mt-3 text-[13.5px] text-slate-600 leading-relaxed">{c.desc}</p>
                <ArrowUpRight className="absolute bottom-5 right-5 w-4 h-4 text-slate-300 group-hover:text-pv-teal group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
              </article>
            );
          })}
        </div>

        <div className="mt-12">
          <SectionActions source="target" items={['demo', 'brochure', 'whatsapp']} />
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
